import { AxiosRequestConfig } from 'axios'

export default class HttpHelper {
    public static UserTokenStorage = 'user-token'

    public static interceptor(config: AxiosRequestConfig) {
        const token = localStorage.getItem(HttpHelper.UserTokenStorage)
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    }

    public static errorInterceptor(err: any) {
        return Promise.reject(err)
    }
}
